import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AgentsRequestsState } from './agents-requests.reducer';

export const selectAgentsRequestsDataState = createFeatureSelector<AgentsRequestsState>('agentsRequests');

export const selectAgentsRequestsList = createSelector(
  selectAgentsRequestsDataState,
  (state: AgentsRequestsState) => { return state.list }
);

export const selectAgentsRequestsPagination = createSelector(
  selectAgentsRequestsDataState,
  (state: AgentsRequestsState) => ({
      pageNumber: state.pageNumber,
      pageSize: state.pageSize,
      totalPages: state.totalPages,
      totalRecords: state.totalRecords
  })
);

export const selectAgentsRequestsDataLoading = createSelector(
    selectAgentsRequestsDataState,
    (state: AgentsRequestsState) => state.loading
);

export const selectAgentsRequestsDataError = createSelector(
    selectAgentsRequestsDataState,
    (state: AgentsRequestsState) => state.error
);

export const selectAgentReqeustDetail = createSelector(
  selectAgentsRequestsDataState,
  (state: any) => {console.log('state.detail',state.detail); return state.detail}
);

export const selectAgentReqeustDetailLoading = createSelector(
  selectAgentsRequestsDataState,
    (state: any) => state.loading
);

export const selectAgentReqeustDetailError = createSelector(
    selectAgentsRequestsDataState,
    (state: AgentsRequestsState) => state.error
);
